import { render, staticRenderFns } from "./dialogWindow.vue?vue&type=template&id=12bbfbb0&scoped=true&"
import script from "./dialogWindow.vue?vue&type=script&lang=js&"
export * from "./dialogWindow.vue?vue&type=script&lang=js&"
import style0 from "./dialogWindow.vue?vue&type=style&index=0&id=12bbfbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbfbb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
